// extracted by mini-css-extract-plugin
export default {"rating":"DE-z","numberOfStars":"EE-z","count":"FE-z","barGraphSpacing":"GE-z","barGraph":"HE-z"};